import { css } from '@emotion/react';

export const fieldMarginStyles = css`
	margin: 0 1.25rem;
`;
